import { RaiseTicketApi, StoreFilesApi } from "../model/RaiseTicketApi";
async function RaiseTicketVM(ticketHeading, ticketDescription, tickettool, ticketfiles, ticketType) {
    const data = new FormData();
    data.append("heading", ticketHeading);
    data.append("description", ticketDescription);
    data.append("tool", tickettool);
    data.append("type", ticketType)
    // console.log(ticketfiles.lenghth == 0);
    let filesData = []
    if (ticketfiles) {
        Array.from(ticketfiles).map((file) => {
            filesData.push({ "name": file.name, "type": file.type })
        })
    }
    if (filesData.length != 0) {
        data.append("files", JSON.stringify(filesData))
    }
    console.log(data);
    let response;
    try {
        response = await RaiseTicketApi(data)
        // console.log("data in raise ");
        console.log(response);
    }
    catch (error) {
        throw "Error Raising Ticket"
    }
        if (response.data.preAssignedUrl.length != 0) {
            let uploaded;
            try {
                // throw new Error("Something went wrong");
                let fileUploads = response.data.preAssignedUrl.map((elem, index) => {
                    return (
                        fetch(elem.url, {
                            method: "PUT",
                            headers: {
                                "Content-Type": elem.filetype
                            },
                            body: ticketfiles[index]
                        })
                    )
                })

                let responses = await Promise.all(fileUploads)
                uploaded = true
                responses.forEach((elem) => {
                    if (!elem.ok) {
                        uploaded = false
                    }
                })
            }
            catch (error) {
                throw "Ticket Raised but Error uploading files";
            }
            if (uploaded) {
                let newfileDetails = response.data.preAssignedUrl.map((elem) => {
                    return (
                        { "key": elem.key, "filetype": elem.filetype, "filename": elem.filename }
                    )
                })
                console.log(newfileDetails);
                let fileDetailsToSend = new FormData()
                // fileDetails.append("key",response.data.preAssignedUrl.key)
                // fileDetails.append("filetype",response.data.preAssignedUrl.filetype)
                fileDetailsToSend.append("ticket_id", response.data.ticket_id)
                fileDetailsToSend.append("fileDetails", JSON.stringify(newfileDetails))
                fileDetailsToSend.append("entity", "Ticket")
                // fileDetails.append("filename",response.data.preAssignedUrl.filename)
                try {
                    let filesApiResponse = await StoreFilesApi(fileDetailsToSend)
                    console.log("response after file storage");
                    console.log(filesApiResponse);
                    return filesApiResponse
                }
                catch (error) {
                    throw "Ticket Raised But Error storing file details"
                }
            }

        }
        else {
            return response
        }
    
    
}

export default RaiseTicketVM